import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Image } from '@zillow/constellation';
import { withPreload, Upsell as Upsell$1 } from '@zillow/zrs-cms';
import StructuredData from '../../components/StructuredData/StructuredData.js';

var ImagePreload = withPreload(Image);
//
var BlockUpsell = function BlockUpsell(_ref) {
  var _ref$attrs = _ref.attrs,
    _ref$attrs$button = _ref$attrs.button,
    button = _ref$attrs$button === void 0 ? 'Learn More' : _ref$attrs$button,
    body = _ref$attrs.body,
    _ref$attrs$color = _ref$attrs.color,
    color = _ref$attrs$color === void 0 ? 'blue' : _ref$attrs$color,
    heading = _ref$attrs.heading,
    id = _ref$attrs.id,
    image = _ref$attrs.image,
    legal = _ref$attrs.legal,
    _ref$attrs$size = _ref$attrs.size,
    size = _ref$attrs$size === void 0 ? 'xs' : _ref$attrs$size,
    url = _ref$attrs.url;
  return /*#__PURE__*/React.createElement(React.Fragment, null, image && /*#__PURE__*/React.createElement(StructuredData, {
    data: {
      '@context': 'https://schema.org/',
      '@type': 'ImageObject',
      'contentUrl': image.src,
      'caption': image.alt,
      'height': image.height,
      'width': image.width
    }
  }), /*#__PURE__*/React.createElement(FullHeightUpsell, {
    body: body,
    button: button,
    color: color,
    heading: heading,
    id: id,
    image: image ? /*#__PURE__*/React.createElement(ImagePreload, {
      src: image.src,
      width: image.width,
      height: image.height,
      alt: image.alt,
      decoding: image.decoding,
      loading: "lazy"
    }) : undefined,
    legal: legal,
    size: size,
    url: url
  }));
};
var FullHeightUpsell = /*#__PURE__*/styled(Upsell$1).withConfig({
  componentId: "sc-vfzerr-0"
})(["height:100%;"]);
BlockUpsell.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    body: PropTypes.string,
    button: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      loading: PropTypes.string
    }),
    legal: PropTypes.string,
    size: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
} : {};
var Upsell = BlockUpsell;

export { Upsell as default };
